/* Query-param serialization for fetchBaseQuery.

   Array params must go out as repeated bracket keys
   (`tag_ids[]=a&tag_ids[]=b`) — fetchBaseQuery's default URLSearchParams
   flattens arrays to a single comma-joined value, which Symfony's
   InputBag::all() rejects with a 400. */
export const serializeParams = (params: Record<string, unknown>): string => {
    const sp = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue
        if (Array.isArray(value)) value.forEach((v) => sp.append(`${key}[]`, String(v)))
        else sp.append(key, String(value))
    }
    return sp.toString()
}
